var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.12227 3.46825L1.94227 0.288255C1.87255 0.217959 1.7896 0.162163 1.69821 0.124086C1.60681 0.0860098 1.50878 0.0664062 1.40977 0.0664062C1.31077 0.0664062 1.21274 0.0860098 1.12134 0.124086C1.02995 0.162163 0.946996 0.217959 0.877274 0.288255C0.737586 0.428777 0.65918 0.618866 0.65918 0.817005C0.65918 1.01514 0.737586 1.20523 0.877274 1.34575L3.53227 4.00075L0.877274 6.65576C0.737586 6.79628 0.65918 6.98637 0.65918 7.18451C0.65918 7.38264 0.737586 7.57273 0.877274 7.71326C0.947354 7.78277 1.03047 7.83776 1.12184 7.87508C1.21322 7.91241 1.31107 7.93133 1.40977 7.93075C1.50848 7.93133 1.60633 7.91241 1.6977 7.87508C1.78908 7.83776 1.87219 7.78277 1.94227 7.71326L5.12227 4.53325C5.19257 4.46353 5.24837 4.38058 5.28644 4.28919C5.32452 4.19779 5.34412 4.09976 5.34412 4.00075C5.34412 3.90175 5.32452 3.80372 5.28644 3.71232C5.24837 3.62093 5.19257 3.53798 5.12227 3.46825Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.945671a88ea73aceb090deda08cf54b9.svg";
export { ForwardRef as ReactComponent };